module.exports = __webpack_public_path__ + "media/svg-new/clock-1d847071.svg";